import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Skip interceptor for auth check endpoints to avoid infinite loops
const SKIP_INTERCEPT = ['/api/auth/me', '/api/auth/refresh', '/api/auth/login', '/api/auth/register', '/api/auth/logout'];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const url = error.config?.url || '';
    const shouldSkip = SKIP_INTERCEPT.some(p => url.includes(p));
    if (error.response?.status === 401 && !error.config._retry && !shouldSkip) {
      error.config._retry = true;
      try {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL || ''}/api/auth/refresh`, {}, { withCredentials: true });
        return api(error.config);
      } catch {
        // Don't redirect, let AuthContext handle it
      }
    }
    return Promise.reject(error);
  }
);

export default api;
